document.addEventListener('DOMContentLoaded', () => {
    let dropzones = document.querySelectorAll('.dropzone');
    if (dropzones.length) {
        let myDropzone = new Dropzone('.dropzone', { 
            url: "/file/upload",
            addRemoveLinks: true,
            maxFiles: 1,
            maxFilesize: 1024 * 5,
            acceptedFiles: 'image/*, application/pdf, text/csv, video/mov, video/mpg, video/mp4,video/*, application/mov',
            dictDefaultMessage: '<i class="fas fa-cloud-upload-alt" style="font-size: 3em"></i><br><br>Dateien ablegen oder klicken um auszuwählen',
            dictFileTooBig: 'Die Datei ist zu groß, es sind maximal {{maxFilesize}} MiB erlaubt',
            dictInvalidFileType: 'Dieses Dateiformat ist nicht erlaubt',
            dictResponseError: 'Der Server antwortete mit einer ungültigen Statusmeldung: ({{statusCode}})',
            dictMaxFilesExceeded: 'Die maximale Anzahl an Dateien wurde erreicht',
            dictRemoveFile: 'Datei entfernen',
            success: function(file, response) {
                if(response.status == 'ok') {
                    let name = this.element.getAttribute('name');
                    let input = document.querySelector('[name="upload[' + name + ']"]');
                    if(input) {
                        input.value = response.filename;
                        input.dispatchEvent(new CustomEvent('change', { 'bubbles': true }));
                    }
                } else {
                    this.removeFile(file);
                }
            },
            init: function() {
                this.hiddenFileInput.removeAttribute('multiple');
                this.on('removedfile', function(file) {
                    let name = this.element.getAttribute('name');
                    let input = document.querySelector('[name="upload[' + name + ']"]');
                    if(input) {
                        input.value = '';
                        input.dispatchEvent(new CustomEvent('change', { 'bubbles': true }));
                    }
                });

                this.on('addedfile', function(file) {
                    if (this.files.length > 1) {
                        this.removeFile(this.files[0]);
                    }
                });
            },
            sending: function(xhr) {
                let dropZone = document.querySelector('.issue-drop-zone');
                if (dropZone) {
                    dropZone.classList.add('uploading');
                }
            },
            accept: function(file, done) {
                const maxFilesize = 1024 * 5;
                let error = false;

                const rules = {
                    'image': { size: maxFilesize },
                    'text': { size: maxFilesize },
                    'application': { size: maxFilesize },
                };

                switch(file.type.substring(0, file.type.indexOf('/'))) {
                    case 'image' :
                        if(file.size > rules.image.size * 1024 * 1024) error = `Bilder dürfen nicht größer als ${rules.image.size} MiB sein.`;
                    break;

                    case 'text':
                    case 'application' :
                        if(file.size > rules.application.size * 1024 * 1024) error = `Dateien dieses Typs dürfen nicht größer als ${rules.application.size} MiB sein.`;
                    break;
                }

                done(error);
            }
        });
    }
});
